import { AutoCompletePropertiesType } from "@website/ui/auto-complete/auto-complete.types";

export const useSwap = (properties: AutoCompletePropertiesType) => {
  const { onSwap } = properties;

  return {
    swapButtonProperties: {
      onClick: onSwap
    }
  };
};
